import type { ReactElement } from 'react';
import { Navigate, Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { PayrollPage } from './PayrollPage';
import { PayrollRunFormPage } from './PayrollRunFormPage';
import { PayrollRunPage } from './PayrollRunPage';
import { PayrollSetupPage } from './PayrollSetupPage';
import { WorkTimePage } from './WorkTimePage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="payroll" permission={permission}>{element}</ModuleGate>;

/** Einstiegspunkt des Moduls Löhne im Backoffice (Schlüssel `payroll`, siehe docs/loehne.md) unter /loehne. */
export const payrollModule: BackofficeModule = {
  key: 'payroll',
  path: '/loehne',
  nav: [{ label: 'Löhne', path: '/loehne' }, { label: 'Arbeitszeiten', path: '/loehne/arbeitszeiten' }],
  // Die Einrichtung der Löhne steht in der Einrichtung des Backoffice, nicht beim Modul. Der Bereich gehört zum Modul „setup“, die Rechte kommen von den Löhnen.
  setupSections: [
    {
      path: 'loehne',
      label: 'Löhne',
      module: 'setup',
      permission: 'payroll.read',
      requires: 'payroll',
      description: 'Gesetzliche Werte, Zahlungstag und Rhythmus, Zusatzbeitrag der Krankenkasse, Umlagen, Berufsgenossenschaft, Kirchensteuer, betrieblicher Mindestlohn, das Konto für die Lohnüberweisung und die Sachkonten für den Lohnaufwand.',
      built: true,
      group: 'team',
      keywords: ['Lohn', 'Gehalt', 'Mindestlohn', 'Zusatzbeitrag', 'Umlage', 'U1', 'U2', 'Berufsgenossenschaft', 'Kirchensteuer', 'IBAN', 'Überweisung', 'Sozialversicherung', 'Sachkonto', 'Konto', 'Buchung', 'Aushilfslöhne', 'Kontenplan', 'SKR03', 'SKR04'],
    },
  ],
  setupRoutes: <Route path="loehne" element={gate('payroll.read', <PayrollSetupPage />)} />,
  routes: (
    <>
      <Route path="loehne" element={gate('payroll.read', <PayrollPage />)} />
      <Route path="loehne/neu" element={gate('payroll.write', <PayrollRunFormPage />)} />
      <Route path="loehne/arbeitszeiten" element={gate('payroll.read', <WorkTimePage />)} />
      <Route path="loehne/einrichtung" element={<Navigate to="/einrichtung/loehne" replace />} />
      <Route path="loehne/:id" element={gate('payroll.read', <PayrollRunPage />)} />
    </>
  ),
};
